import Container from "components/Container";

const Main = () => {
  return <Container></Container>;
};

export default Main;
